import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CAL_IONIC_APPFLOW_MIGRATION_URL } from '@app/config';
import { SectionHeaderComponent } from '@app/widgets';
import { TuiButton, TuiIcon } from '@taiga-ui/core';

@Component({
  selector: 'app-appflow-section',
  imports: [SectionHeaderComponent, TuiButton, TuiIcon],
  templateUrl: './appflow-section.component.html',
  styleUrl: './appflow-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppflowSectionComponent {
  protected readonly migrationUrl = CAL_IONIC_APPFLOW_MIGRATION_URL;

  protected readonly highlights = [
    'An <strong>official recommended alternative</strong> for Capacitor apps',
    '<strong>Full-featured</strong>: Live Updates, Native Builds & App Store Publishing',
    "<strong>Bootstrapped and revenue-generating</strong> — we're here to stay",
    'Used by <strong>thousands of developers</strong> and internally at Capawesome',
  ];
}
